import Ajax from './ajax';

export async function createHtmlToPdf(base64html, base64header, base64footer, fileName = 'document.pdf') {
    try {
        const response = await Ajax.postJsonReturnBlob(
            'api/pdf',
            { body: base64html, header: base64header, footer: base64footer },
            'application/pdf'
        );

        if (response.status === 200) {
            var blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(url);
            return true;
        }
        return false;
    } catch (err) {
        console.log(err);
        return false;
    }
}

export const getStoredSurveyPdf = (surveyId) => {
    return async (dispatch) => {
        try {
            const resp = await Ajax.get('api/pdf/survey/' + surveyId);
            return resp.data;
        } catch (err) {
            console.log(err);
            return null;
        }
    };
};
